import {Types} from "@Common/types";

import {cs} from "@Common/react/chain-services";

import {MultiInputModal} from "../../../common/multi-input-modal/multi-input-modal";

export const Modal = ({
    onSubmit: handleSubmit,
    next,
    value
}:Types.Xpresso.Account.Office.AddressBookRoute.ModalPropsIndiciaFormModal) => cs(
    ["modal", ({}, next:() => any) => MultiInputModal<keyof Types.Xpresso.Account.Office.AddressBookRoute.Indicia>({
        next,
        onSave        : handleSubmit,
        urlParam      : "indicia",

        labelLocation : "left",
        title         : "Manage Bulk Mail Permit",
    })],
    ({modal}:{modal: Types.Xpresso.Account.Common.MultiInputModal.MultiInputModalNext<keyof Types.Xpresso.Account.Office.AddressBookRoute.Indicia>}) => next({
        show: () => modal.show({data: mapValueAsMultiInputModalMappings(value)}),
    }),
);

const mapValueAsMultiInputModalMappings = (value:Types.Xpresso.Account.Office.AddressBookRoute.Indicia): Parameters<Types.Xpresso.Account.Common.MultiInputModal.MultiInputModalNext<keyof Types.Xpresso.Account.Office.AddressBookRoute.Indicia>["show"]>[0]["data"] => {
    return [...Array(5).keys()].map(lineIndex => {
        const fieldName = `line${lineIndex + 1}` as keyof Types.Xpresso.Account.Office.AddressBookRoute.Indicia;
        return {
            'mapping'   : fieldName,
            'label'     : `Line ${lineIndex + 1}`,
            'value'     : value?.[fieldName] || "",
            'maxLength' : 40,
            'xd-qa-type': `label`,
            'xd-qa-name': `Line ${lineIndex + 1}`,
        }
    });
};
